import { NavLink } from 'react-router'
import { FiArrowRight } from 'react-icons/fi'
import { Container, Reveal, RevealGroup, HoverText } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import type { Service } from '@/types/what-we-do'
import { services } from '@/constants/what-we-do'

const ServiceCard = ({ title, description, ring }: Service) => (
  <article className="group">
    <h3 className="text-3xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark transition-colors duration-300 group-hover:text-ibon-sky sm:text-4xl">
      {title[0]}
      <br />
      {title[1]}
    </h3>

    <div className="mt-9 flex items-center gap-3">
      {ring && <span className="h-4 w-4 shrink-0 rounded-full border-2 border-ibon-sky" />}
      <span className="h-px w-40 bg-ibon-dark/20 transition-all duration-500 group-hover:w-56 group-hover:bg-ibon-sky/40" />
    </div>

    <p className="mt-8 max-w-md text-base leading-relaxed text-text-muted">{description}</p>
  </article>
)

export const WhatWeDo = () => {
  return (
    <section className="bg-surface py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Creating opportunity across{' '}
              <span className="text-ibon-dark/30">four core areas.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-text-muted">
              IBON World works at the intersection of entrepreneurship, education, and cultural
              exchange, building practical pathways for collaboration, learning, and long-term
              impact across Africa and the Caribbean.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid gap-y-16 lg:grid-cols-2 lg:gap-x-20">
          <RevealGroup className="flex flex-col gap-16 lg:gap-24 lg:pt-32" step={120}>
            <ServiceCard {...services[0]} />
            <ServiceCard {...services[2]} />
          </RevealGroup>
          <RevealGroup className="flex flex-col gap-16 lg:gap-24" step={120}>
            <ServiceCard {...services[1]} />
            <ServiceCard {...services[3]} />
          </RevealGroup>
        </div>

        <Reveal variant="up" delay={150}>
          <div className="mt-20 border-t border-border pt-10">
            <NavLink
              to={ROUTES.PROGRAMMES}
              className="group/link inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark transition-colors hover:text-ibon-sky"
            >
              <HoverText text="Explore Our Programmes" />
              <FiArrowRight
                className="transition-transform duration-300 group-hover/link:translate-x-1"
                size={14}
              />
            </NavLink>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
